import { useMutation } from "@tanstack/react-query";
import { PhosphorCheckCircle, PhosphorWarning } from "components/Atoms/PhosphorIcon";
import AreYouSureModal from "components/modals/AreYouSureModal";
import { Loading } from "components/panels";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";

interface Props {
  contactSmall: server.dto.ContactSmallV2;
  contactName: server.dto.PersonName;
  extractedFlightPassengerId: number;
  onSuccessfulUpdate?: () => void;
}

export const ContactForExtractorSession = (props: Props) => {
  const { contactSmall, contactName } = props;
  const [isContactPickerOpen, setIsContactPickerOpen] = React.useState(false);
  const [isNewContactModalOpen, setIsNewContactModalOpen] = React.useState(false);

  const aliasMutation = useMutation({
    mutationFn: (contact: server.dto.ContactSmallV2) => window.CoreApi.ContactAlias.Create({
      contactId: contact.contactId,
      name: {
        firstName: contactName.firstName,
        insertion: contactName.insertion,
        lastName: contactName.lastName,
      }
    }),
    onSuccess: () => {
      setIsContactPickerOpen(false);
      props.onSuccessfulUpdate?.();
    }
  });

  if (aliasMutation.isLoading) {
    return <Loading />
  }

  if (contactSmall) {
    return <div className="flex gap-small">
      <div><PhosphorCheckCircle iconSize="regular" iconColor="green" /></div>
      <ContactSidePanel
        contactId={contactSmall.contactId}
        trigger={<a>{contactSmall.name.fullName}</a>}
      /></div>
  }

  return <div>
    <div className="flex gap-small">

      <div><PhosphorWarning iconSize="regular" iconColor="error" /></div>

      <div>
        <div className="flex">
          <div>{contactName.fullName}</div>
        </div>

        <div>
          <a onClick={() => setIsContactPickerOpen(true)}>{RESX.Buttons.btnSelect}</a>
          &nbsp;|&nbsp;
          <a onClick={() => setIsNewContactModalOpen(true)}>
            {RESX.Buttons.btnNew}
          </a>
        </div>
      </div>
    </div>

    {isNewContactModalOpen && <AreYouSureModal
      title={RESX.GeneralWarnings.AreYouSure}
      textContent="Are you sure you want to create a new contact?Only do this when you cannot match the passenger with an existing contact."
      onYes={async () => {
        const resp = await window.CoreApi.Extractor.CreateContactForExtractedFlightPassenger({ extractedFlightPassengerId: props.extractedFlightPassengerId }, { toastOnError: true });
        setIsNewContactModalOpen(false);
        if (!resp.data.hasErrors) {
          props.onSuccessfulUpdate?.();
        }
      }}
      onClose={() => setIsNewContactModalOpen(false)}
      yesButtonLabel={RESX.GeneralLabels.Yes}
      yesButtonColor="green"
    />}

    {
      isContactPickerOpen && <ContactModalPicker
        initialKeyword={contactName.lastName}
        buttonLabel=""
        title="Match contact to passenger"
        onModalClose={() => setIsContactPickerOpen(false)}
        canCreateNew={false}
        nonInPageEditing={{
          onChange: (contact) => aliasMutation.mutate(contact),
          startOpen: true,
          value: undefined,
          required: false,
          validatorKey: "contactModalPicker",
        }}
      />
    }
  </div >
}
